import Router, { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';

import Head from 'next/head';
import axios from 'axios';
import getMetaTagData from '../src/common/services/getMetaTagData';
import MainTop from '../src/component/pc/maintop/MainTop';
import MainBottom from '../src/component/pc/MainBottom/MainBottom';

function Program ({ metaTagData, jWTCheck }) {
  const [ScrollY, setScrollY] = useState(0); // 스크롤값을 저장하기 위한 상태
  const handleFollow = () => {
    setScrollY(window.pageYOffset); // window 스크롤 값을 ScrollY에 저장
  };

  useEffect(() => {
    // console.log('find data childmild ---->>> ScrollY is ', ScrollY); // ScrollY가 변화할때마다 값을 콘솔에 출력
    if (ScrollY > 504) {
      document.getElementById('wrap').className = 'sbsabout_wrap sorting_fixed';
    } else {
      document.getElementById('wrap').className = 'sbsabout_wrap';
    }
  }, [ScrollY]);

  useEffect(() => {
    const watch = () => {
      window.addEventListener('scroll', handleFollow);
    };
    watch(); // addEventListener 함수를 실행
    return () => {
      window.removeEventListener('scroll', handleFollow); // addEventListener 함수를 삭제
    };
  }, []);

  const [btnState, setBtnState] = useState(3); // 상단탭 영역 상태값
  const [bestProgram1990ViewData, setBestProgram1990ViewData] = useState([]);// 현재 나오고있는화면
  const [bestProgram2000ViewData, setBestProgram2000ViewData] = useState([]);// 현재 나오고있는화면
  const [bestProgram2010ViewData, setBestProgram2010ViewData] = useState([]);// 현재 나오고있는화면
  const [bestProgram2020ViewData, setBestProgram2020ViewData] = useState([]);// 현재 나오고있는화면
  const [title, setTitle] = useState(''); // 타이틀 상태값

  const sectionStyle = {
    backgroundImage: 'url(styles/2022/pc/img/program_visual.png)'
  };

  useEffect(() => {
    const config = {
      method: 'get',
      url: 'https://static.cloud.sbs.co.kr/recommend/sbs_programs/1990.json',
      timeout: 3000
    };

    axios(config)
      .then(function (response) {
        const addList = [];
        const addList1 = [];

        // title: "그것이 알고싶다"
        // img_url: "http://img2.sbs.co.kr/ops_pgm_img/2021/12/27/02c7fb0d-5843-4add-95b2-ae136ccbec74834w600.jpg"
        // link_url: "http://programs.sbs.co.kr/culture/unansweredquestions"
        for (let i = 0; i < response.data.list.length; i++) {
          const element = response.data.list[i];
          const item = {
            title: element.title,
            img_url: element.img_url,
            link_url: element.link_url
          };

          // if (i < 10) { // 초기화면
          //   addList1.push(item);
          // }
          addList.push(item);
        }
        setBestProgram1990ViewData(addList); // 초기화면 데이터 뿌리기
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {
      });
  }, []);

  useEffect(() => {
    const config = {
      method: 'get',
      url: 'https://static.cloud.sbs.co.kr/recommend/sbs_programs/2000.json',
      timeout: 3000
    };

    axios(config)
      .then(function (response) {
        const addList = [];
        const addList1 = [];

        // title: "그것이 알고싶다"
        // img_url: "http://img2.sbs.co.kr/ops_pgm_img/2021/12/27/02c7fb0d-5843-4add-95b2-ae136ccbec74834w600.jpg"
        // link_url: "http://programs.sbs.co.kr/culture/unansweredquestions"
        for (let i = 0; i < response.data.list.length; i++) {
          const element = response.data.list[i];
          const item = {
            title: element.title,
            img_url: element.img_url,
            link_url: element.link_url
          };

          // if (i < 10) { // 초기화면
          //   addList1.push(item);
          // }
          addList.push(item);
        }
        setBestProgram2000ViewData(addList); // 초기화면 데이터 뿌리기
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {
      });
  }, []);

  useEffect(() => {
    const config = {
      method: 'get',
      url: 'https://static.cloud.sbs.co.kr/recommend/sbs_programs/2010.json',
      timeout: 3000
    };

    axios(config)
      .then(function (response) {
        const addList = [];
        const addList1 = [];

        // title: "그것이 알고싶다"
        // img_url: "http://img2.sbs.co.kr/ops_pgm_img/2021/12/27/02c7fb0d-5843-4add-95b2-ae136ccbec74834w600.jpg"
        // link_url: "http://programs.sbs.co.kr/culture/unansweredquestions"
        for (let i = 0; i < response.data.list.length; i++) {
          const element = response.data.list[i];
          const item = {
            title: element.title,
            img_url: element.img_url,
            link_url: element.link_url
          };

          // if (i < 10) { // 초기화면
          //   addList1.push(item);
          // }
          addList.push(item);
        }
        setBestProgram2010ViewData(addList); // 초기화면 데이터 뿌리기
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {
      });
  }, []);

  useEffect(() => {
    const config = {
      method: 'get',
      url: 'https://static.cloud.sbs.co.kr/recommend/sbs_programs/2021.json',
      timeout: 3000
    };

    axios(config)
      .then(function (response) {
        const addList = [];
        const addList1 = [];

        // title: "그것이 알고싶다"
        // img_url: "http://img2.sbs.co.kr/ops_pgm_img/2021/12/27/02c7fb0d-5843-4add-95b2-ae136ccbec74834w600.jpg"
        // link_url: "http://programs.sbs.co.kr/culture/unansweredquestions"
        for (let i = 0; i < response.data.list.length; i++) {
          const element = response.data.list[i];
          const item = {
            title: element.title,
            img_url: element.img_url,
            link_url: element.link_url
          };

          // if (i < 10) { // 초기화면
          //   addList1.push(item);
          // }
          addList.push(item);
        }
        setBestProgram2020ViewData(addList); // 초기화면 데이터 뿌리기
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {
      });
  }, []);

  const btnState01 = () => {
    // Router.push({
    //   pathname: '/program',
    //   query: { type: 0 }
    // });
    location.href="/program?type=0";
  };

  const btnState02 = () => {
    // Router.push({
    //   pathname: '/program',
    //   query: { type: 1 }
    // });
    location.href="/program?type=1";
  };

  const btnState03 = () => {
    // Router.push({
    //   pathname: '/program',
    //   query: { type: 2 }
    // });
    location.href="/program?type=2";
  };

  const btnState04 = () => {
    // Router.push({
    //   pathname: '/program',
    //   query: { type: 3 }
    // });
    location.href="/program?type=3";
  };

  const router = useRouter();
  useEffect(() => { // btn state 부분제어 하는 영역
    setBtnState(router.query.type);
  }, [router]);

  useEffect(() => { // btn state 부분제어 하는 영역
    const state = router.query.type;
    if (state === '0') {
      setBtnState(0);
      setTitle('1990-1999 : 대표 프로그램 : SBS 소개 : SBS');
      document.getElementById('tab_0').style.display = 'block';
      document.getElementById('tab_1').style.display = 'none';
      document.getElementById('tab_2').style.display = 'none';
      document.getElementById('tab_3').style.display = 'none';
    } else if (state === '1') {
      setBtnState(1);
      setTitle('2000-2009 : 대표 프로그램 : SBS 소개 : SBS');
      document.getElementById('tab_0').style.display = 'none';
      document.getElementById('tab_1').style.display = 'block';
      document.getElementById('tab_2').style.display = 'none';
      document.getElementById('tab_3').style.display = 'none';
    } else if (state === '2') {
      setBtnState(2);
      setTitle('2010-2020 : 대표 프로그램 : SBS 소개 : SBS');
      document.getElementById('tab_0').style.display = 'none';
      document.getElementById('tab_1').style.display = 'none';
      document.getElementById('tab_2').style.display = 'block';
      document.getElementById('tab_3').style.display = 'none';
    } else if (state === '3') {
      setBtnState(3);
      setTitle('2021-현재 : 대표 프로그램 : SBS 소개 : SBS');
      document.getElementById('tab_0').style.display = 'none';
      document.getElementById('tab_1').style.display = 'none';
      document.getElementById('tab_2').style.display = 'none';
      document.getElementById('tab_3').style.display = 'block';
    } else {
      setBtnState(3);
      setTitle('2021-현재 : 대표 프로그램 : SBS 소개 : SBS');
      document.getElementById('tab_0').style.display = 'none';
      document.getElementById('tab_1').style.display = 'none';
      document.getElementById('tab_2').style.display = 'none';
      document.getElementById('tab_3').style.display = 'block';
    }
  }, [btnState]);

  // gtag
  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      window.dataLayer = window.dataLayer || [];
      function gtag () { dataLayer.push(arguments); }
      gtag('js', new Date());
      gtag('config', 'UA-104756746-1');
      gtag('config', 'G-L9E7Y63ZNE');
    }
  }, []);

  return (
    <>
      <script async src='https://www.googletagmanager.com/gtag/js?id=UA-104756746-1' />
      <Head>
        <link key='css_pc_url' rel='stylesheet' href={process.env.NEXT_PUBLIC_GLOBAL_CSS_PC_URL} />
        <meta key='viewport' name='viewport' content='width=device-width, initial-scale=1' />
        <meta name='description' content='SBS의 대표 프로그램과 서비스 등 30년 히스토리와 최근 소식을 만나보세요!' />
        <meta name='keywords' content={metaTagData.keywords} />
        <meta name='twitter:card' content='summary' />
        <noscript>Your browser does not support JavaScript!</noscript>
        <meta property='og:type' content='website' />
        <meta property='og:locale' content='ko_KR' />
        <meta property='og:site_name' content='SBS' />
        <meta property='og:title' content={'' || ''} />
        <meta property='og:description' content={'SBS의 대표 프로그램과 서비스 등 30년 히스토리와 최근 소식을 만나보세요!' || ''} />
        <meta property='og:image' content={metaTagData.shareImageUrl || ''} />
        <meta property='og:url' content={metaTagData.currentUrl || ''} />
        <meta name='nate:site_name' content='SBS' />
        <meta name='nate:title' content={'' || ''} />
        <meta name='nate:description' content={'SBS의 대표 프로그램과 서비스 등 30년 히스토리와 최근 소식을 만나보세요!' || ''} />
        <meta name='nate:image' content={metaTagData.shareImageUrl || ''} />
        <meta name='nate:url' content={metaTagData.currentUrl || ''} />
        <title>{title}</title>
      </Head>

      <ul id='skip_nav'>
        <li><a href='#container'>본문컨텐츠</a></li>
        <li><a href='#header'>헤더 메뉴</a></li>
      </ul>

      <div id='wrap' className='sbsabout_wrap'>
        {/* <!-- 헤더 --> */}
        <MainTop />
        {/* <!-- 컨텐츠영역 --> */}
        {/* <!-- contents에 년도별 클래스 추가로 제어 "program1990,program2000,program2010,program2021" --> */}
        <div id='container' className='contents program1990'>
          <h2 className='hide'>SBS</h2>
          {/* <!-- 비쥬얼영역 --> */}
          <div className='sbsabout_visual_top_program' style={sectionStyle}>
            <div className='sbsabout_inner'>
              <h3 className='sbsabout_visual_title'>대표 프로그램</h3>
            </div>
          </div>

          {/* <!-- 탭 --> */}
          <div className='module_tablist_w'>
            <div className='sbsabout_inner'>
              <ul className='module_tablist'>
                <li className={`module_tablist_inner ${btnState === 0 ? 'current' : ''}`}>
                  <a href='#none' onClick={btnState01} className='module_tablink'>1990-1999</a>
                </li>
                <li className={`module_tablist_inner ${btnState === 1 ? 'current' : ''}`}>
                  <a href='#none' onClick={btnState02} className='module_tablink'>2000-2009</a>
                </li>
                <li className={`module_tablist_inner ${btnState === 2 ? 'current' : ''}`}>
                  <a href='#none' onClick={btnState03} className='module_tablink'>2010-2020</a>
                </li>
                <li className={`module_tablist_inner ${btnState === 3 ? 'current' : ''}`}>
                  <a href='#none' onClick={btnState04} className='module_tablink'>2021-현재</a>
                </li>
                {/* <li className='module_tablist_inner'>
                  <a href='#none' className='module_tablink'>2021-현재</a>
                </li> */}
              </ul>
            </div>
          </div>

          {/* <!-- 컨텐츠 --> */}
          <div className='program_contents_w'>
            {/* <!-- 1990 --> */}
            <div className='sbsabout_inner tablist_1990' id='tab_0'>
              <div className='tab_term_w'>
                <div className='tab_term_cont'>
                  <strong className='tab_term_title'>대표 프로그램</strong>
                  <strong className='tab_term_years'>1990-1999</strong>
                </div>
              </div>
              <div className='program_list_w'>
                <ul className='module_poster_list_inner'>
                  {bestProgram1990ViewData.map((item, index) => {
                    return (
                      <li key={index} className='module_poster_list_cont'>
                        <div className='post_box_w'>
                          <a href={item.link_url} className='pb_link'>
                            <div className='pb_image_w'>
                              <div className='pb_image_inner'>
                                <img src={item.img_url} className='pb_image' alt={item.title} />
                              </div>
                            </div>
                            <div className='pb_info_w'>
                              <span className='pbif_title'>{item.title}</span>
                            </div>
                          </a>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>

            {/* <!-- 2000 --> */}
            <div className='sbsabout_inner tablist_1990' id='tab_1'>
              <div className='tab_term_w'>
                <div className='tab_term_cont'>
                  <strong className='tab_term_title'>대표 프로그램</strong>
                  <strong className='tab_term_years'>2000-2009</strong>
                </div>
              </div>
              <div className='program_list_w'>
                <ul className='module_poster_list_inner'>
                  {bestProgram2000ViewData.map((item, index) => {
                    return (
                      <li key={index} className='module_poster_list_cont'>
                        <div className='post_box_w'>
                          <a href={item.link_url} className='pb_link'>
                            <div className='pb_image_w'>
                              <div className='pb_image_inner'>
                                <img src={item.img_url} className='pb_image' alt={item.title} />
                              </div>
                            </div>
                            <div className='pb_info_w'>
                              <span className='pbif_title'>{item.title}</span>
                            </div>
                          </a>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>

            {/* <!-- 2010 --> */}
            <div className='sbsabout_inner tablist_1990' id='tab_2'>
              <div className='tab_term_w'>
                <div className='tab_term_cont'>
                  <strong className='tab_term_title'>대표 프로그램</strong>
                  <strong className='tab_term_years'>2010-2020</strong>
                </div>
              </div>
              <div className='program_list_w'>
                <ul className='module_poster_list_inner'>
                  {bestProgram2010ViewData.map((item, index) => {
                    return (
                      <li key={index} className='module_poster_list_cont'>
                        <div className='post_box_w'>
                          <a href={item.link_url} className='pb_link'>
                            <div className='pb_image_w'>
                              <div className='pb_image_inner'>
                                <img src={item.img_url} className='pb_image' alt={item.title} />
                              </div>
                            </div>
                            <div className='pb_info_w'>
                              <span className='pbif_title'>{item.title}</span>
                            </div>
                          </a>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>

            {/* <!-- 2021 --> */}
            <div className='sbsabout_inner tablist_1990' id='tab_3'>
              <div className='tab_term_w'>
                <div className='tab_term_cont'>
                  <strong className='tab_term_title'>대표 프로그램</strong>
                  <strong className='tab_term_years'>2021-현재</strong>
                </div>
              </div>
              <div className='program_list_w'>
                <ul className='module_poster_list_inner'>
                  {bestProgram2020ViewData.map((item, index) => {
                    return (
                      <li key={index} className='module_poster_list_cont'>
                        <div className='post_box_w'>
                          <a href={item.link_url} className='pb_link'>
                            <div className='pb_image_w'>
                              <div className='pb_image_inner'>
                                <img src={item.img_url} className='pb_image' alt={item.title} />
                              </div>
                            </div>
                            <div className='pb_info_w'>
                              <span className='pbif_title'>{item.title}</span>
                            </div>
                          </a>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>

          </div>

        </div>
        {/* <!-- 풋터 --> */}
        <MainBottom />
      </div>

    </>
  );
}

export async function getServerSideProps (ctx) {
  // header에서 meta teg에 넣어줄 데이터를 가져 오기 위함
  const { pageSection, pageCategory } = ctx.query;
  const { cookies } = ctx.req;
  const { LOGIN_JWT } = cookies;

  const jWTCheck = !!LOGIN_JWT;
  const metaTagData = getMetaTagData(ctx.req.url, pageSection, pageCategory);

  return { props: { metaTagData, jWTCheck } };
}

export default Program;
